import { MOCK_MANUFACTURERS } from "../data";
import { ManufacturerState } from "../types";

export const initialState: ManufacturerState = {
  loading: false,
  list: MOCK_MANUFACTURERS,
  priorityFilter: "ALL",
  error: null,
};
